import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { submitSchoolFeedbackForm } from './submitSchoolFeedbackForm';

type SchoolFeedbackFormId = 'school-report' | 'school-confirm';

type SubmitSchoolFeedbackVariables = {
  formId: SchoolFeedbackFormId;
  experienceId: string;
  email?: string;
  notes?: string;
  pdfUrl?: string;
};

export const useSubmitSchoolFeedbackForm = () => {
  const { mutate, ...rest } = useMutation<
    void,
    Error,
    SubmitSchoolFeedbackVariables
  >({
    mutationFn: submitSchoolFeedbackForm,
    retry: false,
  });

  const submitForm = useCallback(
    (
      variables: SubmitSchoolFeedbackVariables,
      options?: Parameters<typeof mutate>[1]
    ) => {
      mutate(variables, options);
    },
    [mutate]
  );

  return { submitForm, ...rest };
};
